import { Translate } from 'react-localize-redux';
import { DescriptiveIntroContainer } from './style/DescriptiveIntro.style';

function DescriptiveIntro() {
  return (
    <DescriptiveIntroContainer>
      <Translate id="text.pendingSessionModal.description" />
    </DescriptiveIntroContainer>
  );
}

export default DescriptiveIntro;
